import { SITE_COLORS } from './siteColors.js'

let filtersIsOpen = false;
let currentPage;
export function filtersMenu(page) {
    $w('#filterMenuBtn,#filterMenuCloseBtn').onClick(() => {
        currentPage = page;
        toggleFilters()
    })
}

export function toggleFilters() {
    filtersIsOpen ? closeFilters() : openFilters();
    filtersIsOpen = !filtersIsOpen;
}

async function openFilters() {
    $w('#filtersSection').scrollTo();
    await $w('#filterMenu').expand();
    if (currentPage === 'home') {
        $w('#filterMenuBtn').style.backgroundColor = SITE_COLORS.filterOpen.background;
        $w('#filterMenuBtn').label = 'Filter by ▲';
    } else {
        $w('#filterMenuBtn').label = '▲';
    }

}

async function closeFilters() {
    await $w('#filterMenu').collapse();
    if (currentPage === 'home') {
        $w('#filterMenuBtn').style.backgroundColor = SITE_COLORS.filterClose.background;
        $w('#filterMenuBtn').label = 'Filter by ▼';
    }else{
         $w('#filterMenuBtn').label = '▼';
    }

}